
import { defineComponent } from 'vue';
import FormInput from '@/components/ui/form/FormInput.vue';
import countriesService from '@/services/countries.service';
import OutlineButton from '@/components/ui/OutlineButton.vue';
import customersService from '@/services/customers.service';
import { Country } from '@/model/country';
import { AppMutation } from '@/store/app/app.mutation';
import { NotificationType } from '@/store/app/notification/notification-type';
import * as yup from 'yup';
import { useField, useForm } from 'vee-validate';
import VueMultiselect from 'vue-multiselect';
import { Customer } from "@/model/customer";
import { AxiosPromise } from "axios";
import { string } from 'yup';
import ContentLoader from '@/components/ui/ContentLoader.vue';

export default defineComponent({
  name: "ClientCreate",
  components: {ContentLoader, OutlineButton, FormInput, VueMultiselect},
  setup() {
    const schema = yup.object({
      name: yup.string().required('Name is required'),
      country: yup.object().shape({
        id: string()
      }).required('Country is required').typeError('Country is required'),
      contactName: yup.string().required('Contact name is required'),
      phone: yup.string().required('Phone is required')
    })

    useForm({
      validationSchema: schema,
    });

    const {value: name, errorMessage: nameError, meta: nameMeta} = useField('name');
    const {value: country, errorMessage: countryError, meta: countryMeta} = useField('country');
    const {value: contactName, errorMessage: contactNameError, meta: contactNameMeta} = useField('contactName');
    const {value: phone, errorMessage: phoneError, meta: phoneMeta} = useField('phone');


    return {
      name,
      nameError,
      nameMeta,
      country,
      countryError,
      countryMeta,
      contactName,
      contactNameError,
      contactNameMeta,
      phone,
      phoneError,
      phoneMeta
    };
  },
  data() {
    return {
      taxNumber: '',
      vat: '',
      vatUk: '',
      eori: '',
      website: '',
      contactPosition: '',
      contactEmail: '',
      address: '',
      zipCode: '',
      city: '',
      state: '',
      countries: [] as Country[],
      customers: [] as Customer[],
      isProcessing: false
    }
  },
  mounted(): void {
    this.isProcessing = true;

    Promise.all([
      countriesService
          .getCountries()
          .then(({data}) => this.countries = data)
    ]);

    this.isProcessing = false;
  },
  methods: {
    handleCancelClick(): void {
      this.$router.push({name: 'customers.list'})
    },
    handleSaveButton(): void {
      this.saveCustomer()
          .then(({data}) => this.$router.push({name: 'customers.list', params: {clientId: data.id}}));
    },
    handleProceedButton(): void {
      this.saveCustomer()
          .then(({data}) => this.$router.push({name: 'proposal.form', params: {clientId: data.id}}));
    },
    saveCustomer(): AxiosPromise<Customer> {
      this.isProcessing = true;

      return customersService.save({
        companyName: this.name as string,
        taxId: this.taxNumber,
        vat: this.vat,
        vatUk: this.vatUk,
        eori: this.eori,
        website: this.website,
        contactName: this.contactName as string,
        contactPosition: this.contactPosition,
        contactEmail: this.contactEmail,
        phone: this.phone as string,
        address: this.address,
        city: this.city,
        state: this.state,
        zipCode: this.zipCode,
        countryId: (this.country as Country)?.id
      })
          .then(response => {
            this.$store.commit(AppMutation.ADD_NOTIFICATION, {
              type: NotificationType.SUCCESS,
              title: 'general.notifications.success',
              content: 'customer.create.notifications.save_success'
            })

            return response;
          })
          .finally(() => this.isProcessing = false);
    }
  }
})
